export default __webpack_public_path__ + "static/media/Javascript-API-Concept-DEV-Community-👩_💻👨_💻.16644422.png";